const setDtm = (props) => {
    window.digitalData = window.digitalData || {};
    window.digitalData = $.extend(true, window.digitalData, props);
};

const trackDtm = (ev, props) => {
    if (window._satellite) {
        setDtm(props);
        window._satellite.track(ev);
    }
}

const handleEmailAnalytics = async (event) => {
    trackDtm("email-tracking-click", {
        email: event?.target?.href || event?.target?.innerText
    });
};


export const addEmailListeners = () => {
    const emailToElems = document.querySelectorAll('a[href*="mailto:"]');

    if (!!emailToElems?.length) {
        for (let elementNode of emailToElems) {
            elementNode.addEventListener("click", (event) => handleEmailAnalytics(event))
        }
    }
}
